import type { ReactNode } from 'react';
import { ErrorBoundary } from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from 'queryClient';
import ThemeCustomization from 'themes';
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import Notistack from 'ui-component/third-party/Notistack';
import { ConfigProvider } from 'contexts/ConfigContext';
import { FirebaseProvider } from 'contexts/FirebaseContext';
import { GoogleMapsProvider } from 'contexts/GoogleMapsContext';

import MetaPixel from '../MetaPixel';
import GoogleAnalytics from '../GoogleAnalytics';
import MsClarity from '../MsClarity';

// ==============================|| APP PROVIDERS ||============================== //
//
// Everything the app is wrapped in, in one place — it used to be split between src/index.jsx
// (config + firebase) and src/App.jsx (the rest), which made the nesting order hard to see.
// The order here is the order those two files produced, unchanged.

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <ConfigProvider>
      <FirebaseProvider>
        <ErrorBoundary fallback={<div>Algo salió mal. Por favor recargá la página.</div>}>
          <QueryClientProvider client={queryClient}>
            <ThemeCustomization>
              <MetaPixel />
              <GoogleAnalytics />
              <MsClarity />
              <Locales>
                <NavigationScroll>
                  <GoogleMapsProvider>
                    <Notistack>{children}</Notistack>
                  </GoogleMapsProvider>
                </NavigationScroll>
              </Locales>
            </ThemeCustomization>
          </QueryClientProvider>
        </ErrorBoundary>
      </FirebaseProvider>
    </ConfigProvider>
  );
}
